import Promise from 'bluebird';
import axios from 'axios';
import {request as requestApi, updateRequest as updateApi} from '../apis/request'

export function request(payload){
    return async (dispatch) => {
        let result = await requestApi(payload);
        console.log("user request result", result);
        return result;
    }
};

export function update(payload){
    return async (dispatch) => {
        let result = await updateApi (payload);
        // console.log("user request result", result);
        return result;
    }
};
